import { render, staticRenderFns } from "./WoocommerceWebhooks.vue?vue&type=template&id=0182d98a&"
import script from "./WoocommerceWebhooks.vue?vue&type=script&lang=js&"
export * from "./WoocommerceWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports